export const companyHeaderTranslations = {
  ru: {
    nav: {
      support: "Поддержка",
      systemsNormal: "Все системы в норме",
      allProjects: "Все проекты экосистемы"
    },
    // Настройки плашки для РУС
    banner: {
      link: "/news/auth-mod", // Ссылка для ру
      text1: "Теперь авторизация на сервере автоматическая! Уже на ",
      highlight1: "Modrinth",
      text2: " и ",
      highlight2: "CurseForge",
      text3: "",
      button: "Подробнее"
    },
    games: {
      survivalTitle: "RPLands",
      survivalDesc: "Приватные майнкрафт сервера",
      creativeTitle: "RPLands Creative",
      creativeDesc: "Творчество без границ",
      kartTitle: "Скоро",
      kartDesc: "(Скоро)",
      rpgTitle: "Скоро",
      rpgDesc: "(Скоро)",
      devTag: "DEV"
    }
  },
  en: {
    nav: {
      support: "Support",
      systemsNormal: "All systems operational",
      allProjects: "All ecosystem projects"
    },
    banner: {
      link: "https://dsc.gg/rplands", 
      text1: "Join our English community on ",
      highlight1: "Discord",
      text2: " to stay updated with ",
      highlight2: "Latest News",
      text3: "!",
      button: "Join Now"
    },
    games: {
      survivalTitle: "RPLands",
      survivalDesc: "Private Minecraft Servers",
      creativeTitle: "RPLands Creative",
      creativeDesc: "Limitless Creativity",
      kartTitle: "Coming Soon",
      kartDesc: "(Coming Soon)",
      rpgTitle: "Coming Soon",
      rpgDesc: "(Coming Soon)",
      devTag: "DEV"
    }
  }
};